import React, { useState, useEffect } from "react";
import { useHistory, Redirect, useLocation } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { request, POST, refreshNewToken } from "../api/ApiAdapter";
import logo from "../assets/images/Appstore-Icon.png";
import img from "../assets/images/City-driver-pana.png";
import {toast, ToastContainer} from "react-toastify";

const Login = () => {
    const history = useHistory();
    const location = useLocation();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [authConfirm, setAuthConfirm] = useState(false);

    const login = async (e) => {
        e.preventDefault();
        try {
            const result = await request("auth/signin", POST, {
                email: username,
                password: password,
            });
            if (!result.error) {
                localStorage.setItem("jwtToken", result.token);
                localStorage.setItem("userId", result.id);
                localStorage.setItem("email", result.email);
                localStorage.setItem("firstName", result.firstName);
                localStorage.setItem("lastName", result.lastName);
                localStorage.setItem("roles", result.roles);
                localStorage.setItem("isAuth", true);
                localStorage.setItem("accountId", result.accountId);
                localStorage.setItem("printType", result.print_type);
                refreshNewToken();
                if (!result.deleted){
                    toast.error("The user access successfully");
                    history.push("/page/usedVehicles", location?.pathname);
                    console.log(result);

                } else {
                    toast.error("The user is inactive");
                }

            } else {
                console.log("Error");
                setAuthConfirm(true);
            }
        } catch (e) {
            console.log(e);
        }
        e.target.reset();
    };

    useEffect(() => {
        localStorage.clear();
    }, []);

    return(
        <>
            <ToastContainer
                position="bottom-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme='colored'
            />
            <div className="lg:flex">
                <div className="hidden lg:flex items-center justify-center bg-accent-light-green flex-1 h-screen">
                    <div className="flex flex-col justify-center">
                        <div className="flex items-center justify-center">
                            <img src={img} className="h-1/2 w-1/2"/>
                        </div>
                        <h2 className="text-primary-dark-green text-center text-3xl font-black">
                            SmartLabel Print Label
                        </h2>
                    </div>
                </div>
                <div className="lg:w-1/2 xl:max-w-screen-sm">
                    <div className="py-12 bg-indigo-100 lg:bg-white flex justify-center lg:justify-center lg:px-12 mt-20">
                        <div className="cursor-pointer flex text-center">
                            <img
                                src={logo}
                                className="h-24 w-24 mt-8 ml-4 rounded-xl"
                            />
                        </div>
                    </div>
                    <div className="mt-10 px-12 sm:px-24 md:px-48 lg:px-12 lg:mt-16 xl:px-24 xl:max-w-2xl">
                        <h2
                            className="text-center font-poppins text-4xl text-primary-dark-green font-display font-bold lg:text-left xl:text-5xl
                    xl:text-bold"
                        >
                            Log in
                        </h2>
                        <div className="mt-12">
                            <form onSubmit={login}>
                                <div>
                                    <div className="text-sm font-bold text-gray-700 tracking-wide">
                                        Enter Username
                                    </div>
                                    <input
                                        className="w-full text-lg py-2 border-b border-gray-300 focus:outline-none focus:border-primary-dark-green"
                                        type="text"
                                        placeholder="Enter Username Here"
                                        onChange={(e) => {
                                            setUsername(e.target.value);
                                        }}
                                    />
                                </div>
                                <div className="mt-8">
                                    <div className="flex justify-between items-center">
                                        <div className="text-sm font-bold text-gray-700 tracking-wide">
                                            Password
                                        </div>
                                    </div>
                                    <input
                                        className="w-full text-lg py-2 border-b border-gray-300 focus:outline-none focus:border-primary-dark-green"
                                        type="password"
                                        placeholder="Enter Password Here"
                                        onChange={(e) => {
                                            setPassword(e.target.value);
                                        }}
                                    />
                                </div>
                                <div className="mt-20">
                                    <div className="text-red-600 text-md font-semibold text-center tracking-wide">
                                        {authConfirm ? "Username or Password is incorrect" : null}
                                    </div>
                                    <button
                                        type="submit"
                                        className="bg-primary-light-blue text-gray-100 p-4 w-full rounded-full tracking-wide
                                font-semibold font-display focus:outline-none focus:shadow-outline hover:bg-blue-600
                                shadow-lg"
                                    >
                                        Log In
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default withRouter(Login);